import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import KpiTile from '../../metrics/KpiTile';
import { formatNumber } from '../../metrics/utils';

const TILES = [
  { key: 'leadCount', field: 'lead_count' },
  { key: 'leadsOpen', field: 'leads_open' },
  { key: 'leadsInProgress', field: 'leads_in_progress' },
  { key: 'leadsClosed', field: 'leads_closed' },
  { key: 'leadsExpired', field: 'leads_expired' },
];

/**
 * All-time lead counts by status, annotated by CampaignSerializer. Shared by
 * the dashboard and mobile detail pages.
 */
export default function CampaignLeadStats({ campaign }) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader
        title={t('campaigns.leadStats.title')}
        subheader={t('campaigns.leadStats.hint')}
        slotProps={{ title: { variant: 'h6' }, subheader: { variant: 'body2' } }}
      />
      <Divider />
      <CardContent>
        <Grid container spacing={2}>
          {TILES.map((tile, index) => (
            <Grid key={tile.key} size={{ xs: index === 0 ? 12 : 6, sm: 'grow' }}>
              <KpiTile
                label={t(`campaigns.leadStats.${tile.key}`)}
                value={formatNumber(campaign[tile.field] ?? 0)}
              />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}
